<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <div class="workflow-node workflow-node--wait_until">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">WAIT UNTIL</div>
        <div class="workflow-node__title">
            {{ data?.config?.event_type || 'Event' }}
            <span v-if="data?.config?.timeout_hours"> ({{ data.config.timeout_hours }}h timeout)</span>
        </div>
        <Handle type="source" :position="Position.Bottom" id="matched" style="left: 25%" />
        <Handle type="source" :position="Position.Bottom" id="timeout" style="left: 75%" />
        <div class="workflow-node__branch-labels">
            <span>Matched</span>
            <span>Timeout</span>
        </div>
    </div>
</template>

<style scoped>
.workflow-node__branch-labels {
    display: flex;
    justify-content: space-between;
    font-size: 9px;
    color: #fbbf24;
    margin-top: 4px;
    padding: 0 2px;
}
</style>
